// statsbox.js — the floating statistics box on the main page.

import { S } from './state.js';
import { toISO, durationSecOf, localDateStr } from '../model.js';

export function updateStats() {
  document.getElementById('openCount').textContent = S.tasks.length;
  // All-time totals: kept in the cloud (meta.totals) because the main page only
  // loads recent history; fall back to what is in memory.
  const ct = S.cloudTotals;
  const totalCount = (ct && typeof ct.count === 'number') ? Math.max(ct.count, 0) : S.completed.length;
  document.getElementById('doneCount').textContent = totalCount;

  let totalSec = 0, todayCount = 0, todaySec = 0;
  const todayStr = localDateStr(new Date());

  S.completed.forEach(c => {
    const sec = durationSecOf(c);
    if (sec === null) return;
    totalSec += sec;
    const iso = toISO(c.completedOn);
    const completedDateStr = iso ? localDateStr(new Date(iso)) : '';
    if (completedDateStr === todayStr) { todayCount++; todaySec += sec; }
  });

  const hm = sec => { const m = Math.floor(sec / 60); return `${Math.floor(m / 60)}:${String(m % 60).padStart(2, '0')}`; };
  const allTimeSec = (ct && typeof ct.seconds === 'number') ? Math.max(ct.seconds, 0) : totalSec;
  document.getElementById('totalTime').textContent = hm(allTimeSec);
  document.getElementById('todayCount').textContent = todayCount;
  document.getElementById('todayTime').textContent = hm(todaySec);

  // Visual streak stream, in the app's own ASCII idiom: a bigger fish per decade.
  const s = S.streak;
  const school = (art, n) => Array.from({ length: n }, () => art).join(' ');
  const stream = [
    school('><((((*>', Math.floor(s / 1000) % 10),
    school('><(((º>', Math.floor(s / 100) % 10),
    school('><((>', Math.floor(s / 10) % 10),
    school('><>', s % 10)
  ].filter(Boolean).join(' ');
  document.getElementById('streakStream').textContent = s > 0 ? stream : '~~~~';
}

export function renderStreakCount() {
  document.getElementById('streakCount').textContent = S.streak;
}

// Statistics are a sign-up incentive: faded with an overlay while anonymous.
export function initStatsVisibility(auth) {
  const statsContent = document.getElementById('statsContent');
  const overlay = document.getElementById('statsOverlay');
  if (!statsContent || !overlay) return;
  // The locked state is the sign-up pitch: make it act like one.
  document.getElementById('statsUnlock')?.addEventListener('click', () => document.getElementById('auth-btn')?.click());
  const apply = (user) => {
    const locked = !(user && !user.isAnonymous);
    statsContent.classList.toggle('is-faded', locked);
    overlay.style.display = locked ? 'flex' : 'none';
    statsContent.setAttribute('aria-hidden', locked ? 'true' : 'false');
  };
  apply(auth.currentUser);
  auth.onAuthStateChanged(apply);
}
